import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function DSSCsUseCase() {
  return (
    <>
    <section
      id="dsscs"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            DSSCs (Dye-Sensitised Solar Cells)
          </h1>
          <p className="text-slate-300 space-y-2">
            Dye-sensitised solar cells (DSSCs) are a class of low-cost, semi-transparent photovoltaic devices that use dye molecules to absorb sunlight and generate electricity.
            Unlike traditional silicon photovoltaics, DSSCs rely on a photoactive dye adsorbed onto a mesoporous semiconductor (typically TiO₂), combined with a redox electrolyte and counter electrode.<sup>[1]</sup> These devices are lightweight, flexible, and can operate under diffuse or indoor light conditions — making them ideal for portable electronics, building integration, and IoT applications.

            <br /><br />

            The performance of DSSCs hinges on the properties of the sensitiser: strong light absorption, appropriate alignment of frontier orbitals with the semiconductor and electrolyte, and high photostability.
            Dyes must inject electrons efficiently into the conduction band and regenerate quickly to maintain photocurrent.
            Molecular engineering is also used to tune absorption spectra, reduce recombination, and improve anchoring groups.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Screen thousands of dye structures with precomputed absorption energies, oscillator strengths, and orbital alignment with semiconductor levels.
    </li>
    <li>
      Predict reorganisation energy and excited-state characteristics to evaluate charge injection efficiency.
    </li>
    <li>
      Assess solubility and identify molecules with reduced aggregation or toxicity profiles.
    </li>
    <li>
      Procure candidate dyes or functionalised precursors directly from suppliers.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            DSSCs offer unique advantages in emerging photovoltaic markets, but dye discovery remains time-consuming and empirical.
            DiaDEM™ supports the design and selection of next-generation sensitisers with digital-first workflows — accelerating R&D, improving efficiency, and expanding the reach of solar energy into new domains.
          </p>
        </div>

        {/* References from our research group */}
<div className="space-y-4 pt-10">
  <h2 className="text-2xl font-semibold text-orange-300">
    References from our group
  </h2>
  <ol className="list-decimal list-inside text-slate-400 space-y-1 text-sm">
    <li>
      Martsinovich, N. & Troisi, A. <i>Theoretical studies of dye-sensitised solar cells: from electronic structure to elementary processes</i>, Energy Environ. Sci. <b>4</b>, 4473–4495 (2011).{" "}
      <a
        href="https://doi.org/10.1039/C1EE01906F"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#F89B3F] underline"
      >
        Link ↗
      </a>
    </li>
  </ol>
</div>


        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
